import { render, staticRenderFns } from "./uni-data-picker.vue?vue&type=template&id=1ab8acc8&scoped=true"
import script from "./uni-data-picker.vue?vue&type=script&lang=js"
export * from "./uni-data-picker.vue?vue&type=script&lang=js"
import style0 from "./uni-data-picker.vue?vue&type=style&index=0&id=1ab8acc8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ab8acc8",
  null
  
)

export default component.exports